module.exports = __webpack_public_path__ + "img/Servicios.c24e651f.png";